import { render, staticRenderFns } from "./cowIndividualInseminationList.vue?vue&type=template&id=783ddba8&scoped=true&"
import script from "./cowIndividualInseminationList.vue?vue&type=script&lang=js&"
export * from "./cowIndividualInseminationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783ddba8",
  null
  
)

export default component.exports